var map = {
	"./ImageMontage": 7577,
	"./ImageMontage.js": 7577,
	"./WebPage": 6822,
	"./WebPage copy": 1610,
	"./WebPage copy.jsx": 1610,
	"./WebPage.jsx": 6822,
	"./images/about/classroom1.jpeg": 4889,
	"./images/about/classroom2.jpeg": 964,
	"./images/about/classroom3.jpeg": 3128,
	"./images/home/ptgm-background.jpeg": 9702,
	"./images/testimonies/student1.jpeg": 5823,
	"./images/testimonies/student2.jpeg": 817,
	"./images/testimonies/student3.jpeg": 8991,
	"./images/testimonies/student4.jpeg": 4524,
	"./images/testimonies/testimonies1.jpeg": 2609,
	"./images/testimonies/testimonies2.jpeg": 6970,
	"./images/tutor/Ain.jpeg": 2493,
	"./images/tutor/AinIzz.jpeg": 6479,
	"./images/tutor/Aisyah.jpeg": 2513,
	"./images/tutor/Allysa.jpeg": 287,
	"./images/tutor/Anis.jpeg": 2476,
	"./images/tutor/Annuar.jpeg": 615,
	"./images/tutor/Anwar.jpeg": 6793,
	"./images/tutor/Dayah.jpeg": 3679,
	"./images/tutor/Erlia.jpeg": 4129,
	"./images/tutor/Peja.jpeg": 6709,
	"./images/tutor/Salleh.jpeg": 6201,
	"./images/tutor/Solehah.jpeg": 4152,
	"./images/tutor/Ziha.jpeg": 7941
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 280;